import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GolizaComponent } from './goliza/goliza.component';
import { GolizaWelcomeComponent } from './goliza-welcome/goliza-welcome.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgOtpInputModule } from 'ng-otp-input';
import { GenericDialogModule } from '../components/generic-dialog/generic-dialog.module';
import { MsgModule } from '../components/msg/msg.module';
import { MatListModule } from '@angular/material/list';
import { RoscazoComponent } from './roscazo/roscazo.component';

const routes = [
  {
    path: 'home',
    component: RoscazoComponent
  }

];


@NgModule({
  declarations: [GolizaComponent, GolizaWelcomeComponent, RoscazoComponent],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MsgModule,
    MatTooltipModule,
    GenericDialogModule,
    NgOtpInputModule,
    MatListModule
  ]
})
export class LandingModule { }
